/** 获取直播地址 */
const getLiveUrl = (roomId: string, webRid?: string) => {
  return webRid
    ? `https://live.douyin.com/${webRid}`
    : `https://live.ixigua.com/${roomId ? `room/${roomId}/` : ''}`
}
export default getLiveUrl
